import React, { useState, useMemo, useEffect } from 'react';
import { Container, Row, Col, Image, Button, Form, Tabs, Tab, Spinner, Alert } from 'react-bootstrap';
import { DragDropContext } from 'react-beautiful-dnd';
import logoImage from '../img/logo.png';
import LeadModal from '../components/marketing/LeadModal'; // Importar o novo modal
import AgendamentoLeadModal from '../components/marketing/AgendamentoLeadModal'; // 1. Importar o novo modal de agendamento
import MarketingKanbanColumn from '../components/marketing/MarketingKanbanColumn'; // Importar o novo componente de coluna
import LandPageServicosTab from '../components/marketing/LandPageServicosTab'; // 1. Importar a nova aba
import PublicacaoServicosTab from '../components/servicos/PublicacaoServicosTab'; // Importar a nova aba
// import { useNavigate } from 'react-router-dom'; // Não é mais necessário aqui
import '../styles/marketing.css'; // Precisaremos criar este CSS
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEntidadeContext } from '../EntidadeContext';
import axios from 'axios';
import { useAlertModal } from '../AlertModalContext'; // 1. Importar o contexto de alerta
import { useAuthContext } from '../context/AuthContext'; // Importar para pegar o usuário logado
import { useUserContext } from '../UserContext'; // Importar o contexto do usuário


const kanbanColumns = [
    { id: 'novo', title: 'Novos Leads', color: '#0d6efd' },
    { id: 'contatado', title: 'Primeiro Contato', color: '#6f42c1' },
    { id: 'negociando', title: 'Em Negociação', color: '#fd7e14' },
    { id: 'aguardando', title: 'Aguardando Decisão', color: '#ffc107' },
    { id: 'convertido', title: 'Convertido', color: '#198754' },
    { id: 'perdido', title: 'Perdido', color: '#6c757d' },
];

const MarketingPage = () => {
    const { showAlertModal } = useAlertModal(); // 2. Obter a função para exibir alertas
    const { loggedInUser: currentUser } = useAuthContext(); // Obter usuário logado
    const { currentUserRole, getPermittedInternalTabs, isLoadingAccessConfig } = useUserContext(); // Obter do contexto do usuário
    const [leads, setLeads] = useState([]);
    const [isLoadingData, setIsLoadingData] = useState(true); // Unifica os loadings
    const [error, setError] = useState(null);

    const [showLeadModal, setShowLeadModal] = useState(false);
    const [selectedLead, setSelectedLead] = useState(null);
    const [isSavingLead, setIsSavingLead] = useState(false); // Estado para controlar o salvamento
    const [filtroResponsavel, setFiltroResponsavel] = useState('');
    const [marketingProfileIds, setMarketingProfileIds] = useState({ standard: [], custom: [] }); // NOVO

    // 2. Novos estados para o modal de agendamento
    const [showAgendamentoModal, setShowAgendamentoModal] = useState(false);
    const [pacienteParaAgendar, setPacienteParaAgendar] = useState(null);

    // Estados e lógica para buscar serviços para a aba de publicação
    const { currentEntidade, supportData, isLoadingSupportData, agendaConfig, isLoadingAgendaConfig } = useEntidadeContext(); // 1. Obter dados de suporte e agenda
    const [servicos, setServicos] = useState([]);
    const [isLoadingServicos, setIsLoadingServicos] = useState(false);

    // Obter abas permitidas para Marketing
    const permittedTabs = useMemo(() => {
        return getPermittedInternalTabs('marketing', currentUserRole);
    }, [getPermittedInternalTabs, currentUserRole, isLoadingAccessConfig]);

    const [activeTab, setActiveTab] = useState('');

    // Define a aba ativa inicial
    useEffect(() => {
        if (permittedTabs.length > 0 && !isLoadingAccessConfig) {
            if (!activeTab || !permittedTabs.some(tab => tab.key === activeTab)) {
                setActiveTab(permittedTabs[0].key);
            }
        }
    }, [permittedTabs, activeTab, isLoadingAccessConfig]);

    useEffect(() => {
        const fetchLeads = async () => {
            if (!currentEntidade) return;
            setIsLoadingData(true);
            setError(null);
            try {
                const response = await axios.get('/api/leads', {
                    params: { entidade_id: currentEntidade.id }
                });
                // A API agora retorna um objeto com 'leads' e 'marketing_profile_ids'
                setLeads(response.data.leads || []);
                setMarketingProfileIds(response.data.marketing_profile_ids || { standard: [], custom: [] });
            } catch (error) {
                setError('Não foi possível carregar os leads.');
                console.error("Erro ao buscar leads:", error);
            } finally {
                setIsLoadingData(false);
            }
        };

        const fetchServicos = async () => {
            if (activeTab === 'mk_lp_servicos' && currentEntidade && servicos.length === 0) {
                setIsLoadingServicos(true);
                try {
                    const response = await axios.get(`/api/landpageservicos?entidade_id=${currentEntidade.id}`);
                    setServicos(response.data.servicos);
                } catch (error) {
                    console.error("Erro ao buscar serviços para publicação:", error);
                } finally {
                    setIsLoadingServicos(false);
                }
            }
        };

        if (activeTab === 'mk_funil_leads') {
            fetchLeads();
        } else if (activeTab === 'mk_lp_servicos') {
            fetchServicos();
        }
    }, [activeTab, currentEntidade, isLoadingSupportData, isLoadingAgendaConfig]); // Adiciona isLoadingAgendaConfig

    const handleCardClick = (lead) => {
        setSelectedLead(lead);
        setShowLeadModal(true);
    };

    const handleShowCreateModal = () => {
        setSelectedLead(null); // Garante que o modal abrirá em modo de criação
        setShowLeadModal(true);
    };

    const handleSaveLead = async (leadData) => {
        setIsSavingLead(true); // Ativa o estado de salvamento
        try {
            if (leadData.id) {
                // Atualizar lead existente
                const response = await axios.put(`/api/leads/${leadData.id}`, leadData);
                // A API retorna { lead: {...} }. Usamos o objeto 'lead' para atualizar o estado.
                if (response.data && response.data.lead) {
                    setLeads(prevLeads => 
                        prevLeads.map(lead => 
                            lead.id === leadData.id ? response.data.lead : lead
                        )
                    );
                }
            } else {
                // Adicionar novo lead
                const response = await axios.post('/api/leads', {
                    ...leadData,
                    entidade_id: currentEntidade.id,
                    status: 'novo', // Status inicial
                });
                // A API retorna { lead: {...} }. Adicionamos o novo lead ao início da lista.
                if (response.data && response.data.lead) {
                    setLeads(prevLeads => [response.data.lead, ...prevLeads]);
                }
            }
            setShowLeadModal(false); // Fecha o modal em caso de sucesso
        } catch (error) {
            console.error("Erro ao salvar lead:", error);
            // 3. Substituir o alert() por uma mensagem mais amigável
            const errorMessage = error.response?.data?.message || 'Não foi possível salvar o lead. Tente novamente.';
            showAlertModal('Erro ao Salvar', errorMessage, 'danger');
        } finally {
            setIsSavingLead(false); // Desativa o estado de salvamento, ocorrendo sucesso ou falha
        }
    };

    // Memo para filtrar os leads com base no responsável selecionado
    const filteredLeads = useMemo(() => {
        if (isLoadingData) { // Usa o estado unificado
            return [];
        }
        if (!filtroResponsavel) {
            return leads; // Se nenhum filtro, retorna todos os leads
        }
        return leads.filter(lead => lead.responsavel_id === filtroResponsavel);
    }, [leads, filtroResponsavel]);

    const onDragEnd = (result) => {
        const { destination, source, draggableId } = result;

        // 1. Verifica se o cartão foi solto fora de uma coluna válida
        if (!destination) {
            return;
        }

        // NOVO: Impede que o usuário arraste manualmente um card para a coluna "Convertido"
        if (destination.droppableId === 'convertido') {
            showAlertModal('Ação Bloqueada', 'Um lead só pode ser movido para "Convertido" através da criação de um agendamento.', 'warning');
            return; // Aborta a operação de arrastar
        }


        // 2. Verifica se o cartão foi solto na mesma posição
        if (destination.droppableId === source.droppableId && destination.index === source.index) {
            return;
        }

        // 3. Atualiza o status do lead que foi movido (Otimista)
        const leadId = parseInt(draggableId);
        const newStatus = destination.droppableId;
        const originalLeads = [...leads];

        setLeads(prevLeads => 
            prevLeads.map(lead => 
                lead.id === leadId ? { ...lead, status: destination.droppableId } : lead
            )
        );

        // 4. Envia a atualização para a API
        axios.patch(`/api/leads/${leadId}/status`, { status: newStatus })
            .catch(error => {
                console.error("Erro ao atualizar status do lead:", error);
                // Reverte para o estado original em caso de erro
                setLeads(originalLeads);
                // 4. Substituir o alert() por uma mensagem mais amigável
                showAlertModal('Erro de Atualização', 'Não foi possível atualizar o status do lead. Tente novamente.', 'danger');
            });
    };

    // NOVO: Memo para filtrar colaboradores com acesso ao módulo de marketing
    const colaboradoresMarketing = useMemo(() => {
        if (!supportData?.allFuncionarios || (!marketingProfileIds.standard.length && !marketingProfileIds.custom.length)) {
            return [];
        }

        const standardIds = new Set(marketingProfileIds.standard);
        const customIds = new Set(marketingProfileIds.custom);

        return supportData.allFuncionarios.filter(f => {
            // O funcionário é de marketing se o seu perfil padrão OU seu perfil customizado estiver na lista de IDs autorizados.
            return (f.standard_role_id && standardIds.has(f.standard_role_id)) ||
                   (f.entidade_perfil_id && customIds.has(f.entidade_perfil_id));
        });
    }, [supportData.allFuncionarios, marketingProfileIds]);

    return (
        <>
            <div style={{ border: '1px solid gray', backgroundColor: '#f5f5f5' }}>
                <div className="header" style={{ minHeight: '80px' }}>
                    <Row className="p-1 align-items-center" style={{ minHeight: 'inherit' }}>
                        <Col xs={12} md={6} style={{ minHeight: '60px' }}>
                            <div className="d-flex align-items-center justify-content-start h-100">
                                <Image src={logoImage} alt="Logo Clínica" style={{ maxHeight: '60px', marginLeft: '12px' }} />
                                <h3 style={{ marginLeft: '15px', marginBottom: '0' }}>Funil de Marketing</h3>
                            </div>
                        </Col>
                        <Col xs={12} md={6} className="d-flex justify-content-end align-items-center">
                            {activeTab === 'mk_funil_leads' && (
                                <div className="d-flex align-items-center gap-3">
                                    <Form.Group controlId="filtroResponsavel" style={{ minWidth: '200px' }}>
                                        <Form.Select 
                                            size="sm" 
                                            value={filtroResponsavel} 
                                            onChange={(e) => setFiltroResponsavel(e.target.value)}
                                        >
                                            <option value="">Filtrar por Responsável</option>
                                            {colaboradoresMarketing.map(colaborador => (
                                                <option key={colaborador.id} value={colaborador.id}>{colaborador.nome}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                    <Button variant="primary" onClick={handleShowCreateModal}>
                                        <FontAwesomeIcon icon="plus" className="me-2" /> Novo Lead
                                    </Button>
                                </div>
                            )}
                        </Col>
                    </Row>
                </div>
                <div className="body p-3">
                    <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)} className="mb-3">
                        {permittedTabs.map(tabInfo => {
                            let tabContent = null;
                            if (tabInfo.key === 'mk_lp_servicos') {
                                tabContent = <LandPageServicosTab initialServicos={servicos} isLoading={isLoadingServicos} />;
                            } else if (tabInfo.key === 'mk_funil_leads') {
                                tabContent = (
                                    isLoadingData || isLoadingSupportData || isLoadingAgendaConfig ? ( // Usa o estado unificado
                                        <div className="text-center"><Spinner animation="border" /></div>
                                    ) : error ? (
                                        <Alert variant="danger">{error}</Alert>
                                    ) : (
                                        <DragDropContext onDragEnd={onDragEnd}>
                                            <Container fluid className="kanban-board-container">
                                                <div className="kanban-board">
                                                    {kanbanColumns.map(column => {
                                                        const columnLeads = filteredLeads.filter(lead => lead.status === column.id);
                                                        return (
                                                            <MarketingKanbanColumn
                                                                key={column.id}
                                                                column={column}
                                                                leads={columnLeads}
                                                                onCardClick={handleCardClick}
                                                                isDropDisabled={column.id === 'convertido'} // Passa a prop para desabilitar o drop
                                                            />
                                                        );
                                                    })}
                                                </div>
                                            </Container>
                                        </DragDropContext>
                                    )
                                );
                            }

                            return (
                                <Tab key={tabInfo.key} eventKey={tabInfo.key} title={tabInfo.title}>
                                    {tabContent}
                                </Tab>
                            );
                        })}
                    </Tabs>
                </div>
            </div>

            {/* Modal para adicionar/editar leads */}
            <LeadModal 
                show={showLeadModal} 
                onHide={() => setShowLeadModal(false)}
                lead={selectedLead}
                colaboradores={colaboradoresMarketing}
                currentUser={currentUser} // Passa o usuário logado para o modal
                isSaving={isSavingLead} // Passa o estado de salvamento para o modal
                showAlertModal={showAlertModal} // 5. Passar a função de alerta para o modal
                onSave={handleSaveLead}
                // 3. Novas props para abrir o modal de agendamento
                onOpenScheduleModal={(paciente) => {
                    setPacienteParaAgendar(paciente);
                    setShowAgendamentoModal(true);
                }}
            />

            {/* 4. Renderiza o novo modal de agendamento */}
            {pacienteParaAgendar && (
                <AgendamentoLeadModal
                    show={showAgendamentoModal}
                    onHide={() => setShowAgendamentoModal(false)}
                    paciente={pacienteParaAgendar}
                    lead={selectedLead}
                    especialidades={supportData.especialidades || []} // 2. Passa as especialidades
                    todosMedicos={supportData.todosMedicos || []} // 3. Passa os médicos
                    servicos={supportData.servicos || []} // NOVO: Passa os serviços
                    agendaConfig={agendaConfig}
                    onLeadUpdated={(updatedLead) => {
                        // Atualiza o lead na lista local para refletir a mudança no Kanban
                        setLeads(prevLeads => 
                            prevLeads.map(l => l.id === updatedLead.id ? updatedLead : l)
                        );
                    }}
                />
            )}
        </>
    );
};

export default MarketingPage;
